{
  "CSAT": {
    "TITLE": "Valora la teva conversa",
    "PLACEHOLDER": "Explica'ns més...",
    "RATINGS": {
      "POOR": "😞 Pobre",
      "FAIR": "😑 Just",
      "AVERAGE": "😐 Mitjana",
      "GOOD": "😀 Bé",
      "EXCELLENT": "😍 Excel·lent"
    }
  }
}
